<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-08 16:06:13
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-16 15:28:31
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/enterprise_home_page/components/bannerCard.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <van-swipe class="my-swipe" :show-indicators='false' :height='215' :autoplay="3000">
      <template v-if="detail.bannerUrls.length" >
        <van-swipe-item v-for="(item, index) in detail.bannerUrls" :index="index">
          <img :src="item.fileUrl" alt="" style="width:100%;height:100%">
        </van-swipe-item>
      </template>
      <van-swipe-item v-else>
        <img :src="defaultBanner" alt="" style="width:100%;height:100%">
      </van-swipe-item>
     
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: 'bannercard',
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      defaultBanner:'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/enterpriseBanner.jpg'
    }
  },

  mounted() {},

  methods: {},
}
</script>


<style>
.my-swipe .van-swipe-item {
  /* background-color: #39a9ed; */
}
</style>